import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { apply, put, race, take, takeLatest } from 'redux-saga/effects';
import { select, call } from 'typed-redux-saga';
import * as api from 'data/api';
import { transformCountryBoundsDto } from 'data/transformers/country-bounds';
import { transformPickupPointsDto } from 'data/transformers/pickup-point';
import { transformShippingOptionDtos } from 'data/transformers/shipping-option';
import { geocodeAddress } from 'data/utils/google';
import * as sessionSelectors from 'state/session/selectors';
import { Screen } from 'constants/tracking/screens';
import { UiState } from 'constants/ui';
import { tracker } from 'libs/common/tracker';
import { buyerLoadShippingPointsEvent } from 'libs/common/event-tracker/events';
import * as checkoutSelectors from '../selectors';
import { actions, statelessActions, selectors } from './index';
import { getShippingPointsCount } from '../utils';
export function* fetchCountryBounds() {
  const sessionCountryId = yield* select(sessionSelectors.getCountryId);
  const address = yield* select(checkoutSelectors.getAddress);
  const countryId = (address === null || address === void 0 ? void 0 : address.countryId) || sessionCountryId;
  if (!countryId) return;
  const response = yield* call(api.getCountryBounds, countryId);
  if ('errors' in response) return;
  const countryBounds = transformCountryBoundsDto(response.country_bounds);
  yield put(actions.fetchCountryBoundsSuccess({
    countryBounds
  }));
}
export function* fetchNearbyShippingPoints(_ref) {
  var _shipment$carrier;

  let {
    payload
  } = _ref;
  const address = yield* select(checkoutSelectors.getAddress);
  const userCountryCode = yield* select(sessionSelectors.getUserCountryCode);
  const shipment = yield* select(selectors.getShipment);
  const formattedAddress = yield* select(checkoutSelectors.getFormattedAddress);
  const countryCode = (address === null || address === void 0 ? void 0 : address.countryIsoCode) || userCountryCode;
  const carrierId = shipment === null || shipment === void 0 ? void 0 : (_shipment$carrier = shipment.carrier) === null || _shipment$carrier === void 0 ? void 0 : _shipment$carrier.id;
  const {
    coordinates,
    shouldLabelNearestPoints
  } = payload;
  let latitude;
  let longitude;
  if (!carrierId) return;

  if (coordinates) {
    latitude = coordinates.latitude;
    longitude = coordinates.longitude;
  } else if (shipment !== null && shipment !== void 0 && shipment.pickupPoint) {
    latitude = Number(shipment.pickupPoint.latitude);
    longitude = Number(shipment.pickupPoint.longitude);
  } else if (formattedAddress) {
    const geocodedAddress = yield* call(geocodeAddress, formattedAddress);
    latitude = geocodedAddress === null || geocodedAddress === void 0 ? void 0 : geocodedAddress.geometry.location.lat();
    longitude = geocodedAddress === null || geocodedAddress === void 0 ? void 0 : geocodedAddress.geometry.location.lng();
  }

  yield put(statelessActions.fetchNearbyShippingOptionsRequest({
    countryCode,
    longitude,
    latitude,
    shouldLabelNearestPoints
  }));
}
export function* fetchNearbyPointsByElement(_ref2) {
  let {
    payload: {
      coordinates,
      element,
      shouldLabelNearestPoints
    }
  } = _ref2;
  yield put(actions.fetchNearbyShippingPointsRequest({
    coordinates,
    shouldLabelNearestPoints
  }));
  yield put(actions.setPickupModalElementUiState({
    element,
    uiState: UiState.Pending
  }));
  const raceResult = yield race({
    optionsSuccess: take(actions.fetchNearbyShippingOptionsSuccess),
    optionsFailure: take(actions.fetchNearbyShippingOptionsFailure)
  });

  if (raceResult.optionsSuccess) {
    yield put(actions.setPickupModalElementUiState({
      element,
      uiState: UiState.Success
    }));
  } else if (raceResult.optionsFailure) {
    yield put(actions.setPickupModalElementUiState({
      element,
      uiState: UiState.Failure
    }));
  }
}
export function* trackShippingPointsLoad(_ref3) {
  let {
    payload: {
      latitude,
      longitude,
      pickupPoints
    }
  } = _ref3;
  const transactionId = yield* select(checkoutSelectors.getTransactionId);
  const shippingOptions = yield* select(selectors.getShippingOptions);
  if (!latitude || !longitude || !pickupPoints) return;
  const shippingPointsCount = getShippingPointsCount(pickupPoints, shippingOptions);
  const loadShippingPointsEvent = buyerLoadShippingPointsEvent({
    transactionId,
    screen: Screen.PickupPointMap,
    shippingPointsCount: shippingPointsCount ? JSON.stringify(shippingPointsCount) : null,
    latitude: Number(latitude),
    longitude: Number(longitude)
  });
  yield apply(tracker, tracker.track, [loadShippingPointsEvent]);
}
export function* fetchNearbyShippingOptions(_ref4) {
  let {
    payload
  } = _ref4;
  const {
    latitude,
    longitude
  } = payload;
  let nearbyShippingPoints = [];
  const transactionId = yield* select(checkoutSelectors.getTransactionId);
  if (!transactionId) return;

  try {
    const response = yield* call(api.getNearbyShippingOptions, _objectSpread({
      transactionId
    }, payload));

    if ('errors' in response || !response.nearby_shipping_points.length) {
      yield put(actions.fetchNearbyShippingOptionsFailure());
      return;
    }

    const {
      nearby_shipping_points,
      nearby_shipping_options,
      suggested_shipping_point_code,
      suggested_rate_uuid
    } = response;
    nearbyShippingPoints = transformPickupPointsDto(nearby_shipping_points);
    const nearbyShippingOptions = transformShippingOptionDtos(nearby_shipping_options);
    const suggestedShippingPointCode = suggested_shipping_point_code;
    const suggestedRateUuid = suggested_rate_uuid;
    yield put(actions.fetchNearbyShippingOptionsSuccess({
      nearbyShippingPoints,
      nearbyShippingOptions,
      suggestedShippingPointCode,
      suggestedRateUuid
    }));
  } finally {
    yield put(statelessActions.trackShippingPointsLoad({
      latitude,
      longitude,
      pickupPoints: nearbyShippingPoints
    }));
  }
}
export default function* saga() {
  yield takeLatest(statelessActions.fetchCountryBoundsRequest, fetchCountryBounds);
  yield takeLatest(statelessActions.trackShippingPointsLoad, trackShippingPointsLoad);
  yield takeLatest(statelessActions.fetchNearbyPointsByElementRequest, fetchNearbyPointsByElement);
  yield takeLatest(actions.fetchNearbyShippingPointsRequest, fetchNearbyShippingPoints);
  yield takeLatest(statelessActions.fetchNearbyShippingOptionsRequest, fetchNearbyShippingOptions);
}